// 1.D.8 Role-badge. Pieni inline-merkki kayttajan roolista.
// "admin" → rose (käyttäjä jolla on bypass-oikeus kaikkiin projekteihin).
// "user" → emerald (peruskäyttäjä). Muut roolit nayttavat vakioformaatin.

export type RoleBadgeProps = {
  role: string;
};

/** Lyhyt label roolille (UI-naytto). */
export function labelForRole(role: string): string {
  switch (role) {
    case "admin":
      return "admin";
    case "user":
      return "käyttäjä";
    default:
      return role;
  }
}

/** Tailwind-luokat roolin varimerkille. */
export function classForRole(role: string): string {
  switch (role) {
    case "user":
      return "border-emerald-700 bg-emerald-900/40 text-emerald-200";
    case "admin":
      return "border-rose-700 bg-rose-900/40 text-rose-200";
    default:
      return "border-slate-700 bg-slate-900/40 text-slate-300";
  }
}

export function RoleBadge({ role }: RoleBadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium uppercase tracking-wide ${classForRole(role)}`}
    >
      {labelForRole(role)}
    </span>
  );
}

/** Banneri joka kertoo admin-roolisen näkemän bypass-säännön. */
export function AdminBanner() {
  return (
    <div className="border-b border-rose-900 bg-rose-950/40">
      <div className="mx-auto max-w-6xl px-6 py-2 text-xs text-rose-200">
        Admin-näkymä — näet kaikkien käyttäjien projektit ja assetit.
      </div>
    </div>
  );
}
